import {HttpAxiosRequest} from "../httpAxiosBase";
import {
    AuthorizationRequest,
    AuthorizationRequestFields,
    AuthorizationResponse, GoogleAuthFields, GoogleAuthorizationRequest
} from "../../types/user/authData";
import {ConfigurationEconde, configurationEncoder} from "../../utils/configurations";
import {CryptoJSHelper} from "../../utils/helpers/cryptoJSHelper";

export const HttpAuth = {
    getEndpoint: (url: string) => `auth${url}`,

    authenticateUser: async (requestParams: AuthorizationRequest): Promise<AuthorizationResponse> => {
        const encoder: ConfigurationEconde = await configurationEncoder.getConfiguration();
        const encryptPassword: string = CryptoJSHelper.encrypt(encoder, requestParams[AuthorizationRequestFields.Password]);
       
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint(""),
            {
                [AuthorizationRequestFields.Mail]: requestParams.mail,
                [AuthorizationRequestFields.ClientIp]: requestParams.ipClient,
                [AuthorizationRequestFields.Password]: encryptPassword
            }
        );
    },

    authenticateWithGoogle: async (requestParams: GoogleAuthorizationRequest): Promise<AuthorizationResponse> => {
        return HttpAxiosRequest.post(
            HttpAuth.getEndpoint("/google"),
            {
                [GoogleAuthFields.Token]: requestParams.token,
            }
        );
    }
    
    /*ping: async () : Promise<number> => {
        return HttpAxiosRequest.get(
            HttpAuth.getEndpoint("/ping")
        )
    }*/
}